var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.786 5.8A6.25 6.25 0 1 0 18.25 12a.75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-6.775-7.688.75.75 0 1 1-.189 1.488",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.47 2.47a.75.75 0 0 1 1.06 0l1.647 1.646a1.25 1.25 0 0 1 0 1.768L12.53 7.53a.75.75 0 1 1-1.06-1.06L12.94 5l-1.47-1.47a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })));
};
export default SvgRefresh;